<div class="page-header">
  <storybook-breadcrumb
    class="page-header__breadcrumb"
    [list]="breadcrumbList"></storybook-breadcrumb>
  <h1 class="page-header__title">{{ title }}</h1>
  <div class="page-header__action">
    <ng-content></ng-content>
  </div>
</div>
